import notification from 'antd/lib/notification';
import { useEffect, useState } from 'react';

import useAutoCredRequestId from '@/components/App/NewOrder/hooks/useAutoCredRequestId';
import { useAppDispatch, useAppSelector } from '@/store';
import {
  getAttachedFilesByReqId,
  onSetSelectedBank,
  setShouldUpdateBankInfo
} from '@/store/financingStep.slice';
import { getRequestById } from '@/store/newOrder.slice';
import {
  getEuBankStatus,
  getResponsesByRequestId
} from '@/store/offerStep.slice';

import useLoadDocuments from '../../../hooks/useLoadDocuments';

const useEurasStatus = () => {
  const dispatch = useAppDispatch();

  const { selectedBank, shouldUpdateBankInfo } = useAppSelector(
    (state) => state.financingStep
  );
  const { banksOffers } = useAppSelector((state) => state.offerStep);

  const { requestId } = useAutoCredRequestId();

  const [updateStatusLoading, setUpdateStatusLoading] = useState(false);

  const { handleLoadEuBankFiles } = useLoadDocuments();

  const handleChangeEuBankStatus = async () => {
    setUpdateStatusLoading(true);

    const data = {
      requestId: requestId,
      responseExtUuid: selectedBank?.extId || ''
    };
    let isResponseValid;
    if (selectedBank?.bank?.name === 'eu_bank_v2') {
      isResponseValid = (
        await dispatch(getResponsesByRequestId({ reqId: requestId }))
      ).payload;
      isResponseValid = isResponseValid
        ? (await dispatch(getAttachedFilesByReqId(requestId))).payload
        : false;
      await dispatch(getRequestById({ reqId: requestId }));
    } else {
      isResponseValid = (await dispatch(getEuBankStatus(data))).payload;
    }

    if (isResponseValid !== null && isResponseValid !== undefined) {
      notification.success({
        title: 'Успех',
        description: 'Статусы банка обновлены',
        duration: 5
      });
    } else {
      notification.error({
        title: 'Ошибка',
        description: 'Ошибка обновления статуса',
        duration: 5
      });
    }
    setUpdateStatusLoading(false);
  };

  useEffect(() => {
    if (shouldUpdateBankInfo?.includes('eu_bank')) {
      dispatch(setShouldUpdateBankInfo(''));
      handleLoadEuBankFiles();
    }
  }, [shouldUpdateBankInfo]);

  useEffect(() => {
    if (!selectedBank?.bank?.name.includes('eu_bank')) return;
    const eblank = banksOffers.find((offer) =>
      offer.bank?.name.includes('eu_bank')
    );
    if (eblank) dispatch(onSetSelectedBank(eblank));
  }, [banksOffers]);

  return { updateStatusLoading, handleChangeEuBankStatus };
};

export default useEurasStatus;
